import React, { MouseEvent } from "react";
import { MaterialDesignIcons } from "../styled";

export const SyntAudioMIcon: React.FC<{
  fontSize?: string;
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
}> = ({ fontSize, onClick }) => {
  return (
    <MaterialDesignIcons fontSize={fontSize} onClick={onClick}>
      lyrics
    </MaterialDesignIcons>
  );
};
